const ac = window.matchMedia('(max-width: 480px)');
const acBtn = document.getElementById('name-ac-btn');
const acArea = document.getElementById('name-ac-area');

function handleAcMediaQuery(e) {
    if (e.matches) {
        acArea.classList.add('is-ac-close');
        acBtn.addEventListener('click', function () {
            acBtn.classList.toggle('state-open');
            acArea.classList.toggle('is-ac-close');
        }, { passive: true });
    } else {
        ;
    }
};

if (acBtn && acArea) {
    handleAcMediaQuery(ac);
    ac.addEventListener('change', handleAcMediaQuery, false);
}